import { render, staticRenderFns } from "./AuthTextarea.vue?vue&type=template&id=7c6c2708&"
import script from "./AuthTextarea.vue?vue&type=script&lang=js&"
export * from "./AuthTextarea.vue?vue&type=script&lang=js&"
import style0 from "./AuthTextarea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports